var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembershipBannerBg = function SvgMembershipBannerBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 40,
    viewBox: "0 0 204 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4325_105760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 204,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 40,
    rx: 5,
    fill: "url(#paint0_linear_4325_105760)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4325_105760)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M152.283 12.491C152.283 13.6685 151.377 14.5835 150.307 14.5835C149.237 14.5835 148.331 13.6685 148.331 12.491C148.331 11.3135 149.237 10.3984 150.307 10.3984C151.377 10.3984 152.283 11.3135 152.283 12.491Z",
    stroke: "#C0ACDF",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M58.2539 13.5353C58.2539 15.2335 56.9445 16.5706 55.3769 16.5706C53.8094 16.5706 52.5 15.2335 52.5 13.5353C52.5 11.8371 53.8094 10.5 55.3769 10.5C56.9445 10.5 58.2539 11.8371 58.2539 13.5353Z",
    stroke: "#C0ACDF",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.1763,
    cy: 1.64948,
    rx: 10.5811,
    ry: 11.0772,
    fill: "white",
    fillOpacity: 0.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4325_105760",
    x1: 334.539,
    y1: 20,
    x2: 7.92746,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.073745,
    stopColor: "#ED64A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F35B4"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembershipBannerBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/membershipBannerBg.8642e6b9d4cc83960e9e0f3099f94775.svg";